import { addToDateString } from "@/utils/date";
import { computed, Ref } from "vue";
import { IAuftrag, IZeit } from "../api/useAuftrag";

export function useNextStartzeit(
  zeiten: Ref<IZeit[]>,
  auftrag?: Ref<IAuftrag | undefined>,
  auftragAbholung?: Ref<string | null>,
) {
  const nextStartzeit = computed(() => {
    const abholung = auftragAbholung?.value || auftrag?.value?.abholung.datum;
    if (zeiten.value.length === 0) return abholung;
    return addToDateString(zeiten.value[zeiten.value.length - 1].ende.zeit, {
      minutes: 1,
    });
  });

  return {
    nextStartzeit,
  };
}
